<template>
	<auth-container :page="page">
		<h2 class="mb-4">Create New Application</h2>

		<sr-application-form :item="item" :set-options="setOptions"></sr-application-form>
	</auth-container>
</template>

<script>
	import SrApplicationForm from './SrApplicationForm.vue';
	export default {
		name: 'SrApplicationCreate',
		components: {
			SrApplicationForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					appNum: null,
					receivedDate: null,
					damId: null,
					fundCycle: null,
					sloAgent: null,
					primaryName: null,
					alternateName: null,
					requestType: null,
					notes: null,
					scoreDate: null,
					score: 0,
					federalCostShare: 0,
					stateCostShare: 0,
					sloCostShare: 0
				},
				setOptions: {
					requestTypes: []
				}
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				try {
					const response = await this.$http.get(`srapplications/options`, this.getTokenHeader());
					this.setOptions = response.data;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			}
		}
	}
</script>